"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isExpressionRelationshipAttr = isExpressionRelationshipAttr;
const relationship_guard_1 = require("./relationship.guard");
function isExpressionRelationshipAttr(attr) {
    return (0, relationship_guard_1.isRelationshipAttr)(attr) && attr.value.relation.relationType === 'expression';
}
//# sourceMappingURL=relationship.expression.guard.js.map